import * as _ from 'lodash';
import { Box, Divider, IconButton, Flex, Avatar, Text } from '@vibe/core';
import { MondayLogoOutline, Delete, Edit } from '@vibe/icons';
import { useNavigate } from 'react-router';
import { RelativeTime } from '@gorilla/ui/src/components/RelativeTime';
import { SpreadsheetsIndexEntry } from '../services/spreadsheets';

type SpreadsheetsListProps = {
  spreadsheets: SpreadsheetsIndexEntry[];
  onDeleteClick: (spreadsheet: SpreadsheetsIndexEntry) => void;
};

export function SpreadsheetsList({ spreadsheets, onDeleteClick }: SpreadsheetsListProps) {
  const navigate = useNavigate();

  return (
    <Box>
      {_.orderBy(spreadsheets, 'updated_at')
        .reverse()
        .map((spreadsheet, i) => (
          <div key={spreadsheet.id}>
            <Box padding="medium" paddingStart="large" paddingEnd="large" className="list--element">
              <Flex gap="medium" align="center" direction="row">
                <Avatar type="icon" size="medium" withoutBorder={true} icon={MondayLogoOutline} customBackgroundColor="#0073ea" square />
                <Box>
                  <Flex gap="small">
                    <div style={{ maxWidth: '300px' }}>
                      <Text type="text2" weight="medium" ellipsis>
                        {spreadsheet.title}
                      </Text>
                    </div>
                  </Flex>
                  <Flex gap="small">
                    <Box>
                      <div
                        style={{
                          marginTop: '-3px',
                          fontSize: '12px',
                          color: '#afb0bd',
                        }}
                      >
                        Updated <RelativeTime date={spreadsheet.updated_at} />
                      </div>
                    </Box>
                  </Flex>
                </Box>

                <Box style={{ marginLeft: 'auto' }}>
                  <Flex gap={0} align="center" direction="row">
                    <IconButton
                      icon={Delete}
                      size="small"
                      tooltipContent="Delete spreadsheet"
                      onClick={() => {
                        onDeleteClick(spreadsheet);
                      }}
                    />
                    <IconButton
                      icon={Edit}
                      size="small"
                      tooltipContent="Edit spreadsheet"
                      onClick={() => {
                        navigate(`/spreadsheet/${spreadsheet.id}/render`);
                      }}
                    />
                  </Flex>
                </Box>
              </Flex>
            </Box>
            {/* {spreadsheets.length > 3 && spreadsheets.length === i + 1 ? null : <Divider withoutMargin={true} />} */}
            {spreadsheets.length === i + 1 ? null : <Divider withoutMargin={true} />}
          </div>
        ))}
    </Box>
  );
}
